function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
var ServiceSolutionHubClass = /*#__PURE__*/function () {
  function ServiceSolutionHubClass() {
    var _this = this;
    _classCallCheck(this, ServiceSolutionHubClass);
    // Init code
    this.target = document.querySelector('.component-servicesolutionhub');
    this.tags = this.target.querySelectorAll('.js-tag');
    this.divForTags = this.target.querySelectorAll('.js-part');

    // Seo Zone
    if (document.querySelector('.js-zone-seo')) {
      this.seoZone = document.querySelector('.js-zone-seo');
      this.btnMoreChapter = this.seoZone.querySelector('.js-more-chapter');
      this.btnLessChapter = this.seoZone.querySelector('.js-less-chapter');
      this.seoChapters = this.seoZone.querySelector('.js-chapters');
      this.chaptersManager();
    }

    // Listen when the HTML is loaded
    window.addEventListener('DOMContentLoaded', function () {
      sessionStorage.clear();
      if (!_toConsumableArray(_this.tags).filter(function (el) {
        return el.children[0].checked;
      }).length > 0) {
        _this.removeInvisibleState();
      }
    }, false);

    // Verif is session exist
    if (sessionStorage.getItem('element_visible')) {
      this.filtersState = JSON.parse(sessionStorage.getItem('element_visible'));
      var isAllFiltersNotSelected = this.filtersHasNotSelected(this.filtersState);
      if (isAllFiltersNotSelected) {
        this.reset();
      } else {
        this.updateDisplay('');
      }
    } else {
      this.reset();
    }
    if (this.tags.length > 0) {
      this.filterTags();
    }
    this.accordion();
  }
  return _createClass(ServiceSolutionHubClass, [{
    key: "filterTags",
    value: function filterTags() {
      var _this2 = this;
      var message = document.querySelector('.js-update-message').dataset.message;
      var _iterator = _createForOfIteratorHelper(this.tags),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tag = _step.value;
          tag.addEventListener('change', function (event) {
            var id = event.target.closest('.js-tag').dataset.id;
            var filter = event.target.closest('.js-tag').querySelector('.mc-tag-selectable__label').innerText;
            // Update object props
            _this2.filtersState[id] = !_this2.filtersState[id];

            // Stock state in session
            sessionStorage.setItem('element_visible', JSON.stringify(_this2.filtersState));

            // allows displaying all if there is no filter selected
            var isAllFiltersNotSelected = _this2.filtersHasNotSelected(_this2.filtersState);
            if (isAllFiltersNotSelected) {
              var _iterator2 = _createForOfIteratorHelper(_this2.divForTags),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var divForTag = _step2.value;
                  divForTag.classList.remove('invisible');
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } else {
              _this2.updateDisplay("".concat(message, " : ").concat(filter));
            }
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "updateDisplay",
    value: function updateDisplay(message) {
      document.querySelector('.js-update-message-status').innerText = '';
      document.querySelector('.js-update-message-status').innerText = message;
      var _iterator3 = _createForOfIteratorHelper(this.divForTags),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var divForTag = _step3.value;
          if (this.filtersState[divForTag.id]) {
            divForTag.classList.remove('invisible');
          } else {
            divForTag.classList.add('invisible');
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "removeInvisibleState",
    value: function removeInvisibleState() {
      if (this.filtersHasNotSelected(this.filtersState)) {
        var _iterator4 = _createForOfIteratorHelper(this.divForTags),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var divForTag = _step4.value;
            divForTag.classList.remove('invisible');
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }

    // Check if all props obj is false
  }, {
    key: "filtersHasNotSelected",
    value: function filtersHasNotSelected(currentFilters) {
      return Object.values(currentFilters).every(function (filter) {
        return !filter;
      });
    }
  }, {
    key: "accordion",
    value: function accordion() {
      this.myAccordions = this.target.querySelectorAll('.js-accordion');
      if (this.myAccordions) {
        var _iterator5 = _createForOfIteratorHelper(this.myAccordions),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var myAccordion = _step5.value;
            try {
              new Accordion(myAccordion);
            } catch (error) {
              throw new Error("Error : ".concat(error));
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.filtersState = {
        repair: false,
        maintenance: false,
        laying: false
      };
    }
  }, {
    key: "chaptersManager",
    value: function chaptersManager() {
      var _this3 = this;
      if (this.btnMoreChapter) {
        this.btnMoreChapter.addEventListener('click', function () {
          _this3.loadMoreChapters();
        });
      }
      if (this.btnLessChapter) {
        this.btnLessChapter.addEventListener('click', function () {
          _this3.loadLessChapters();
        });
      }
    }
  }, {
    key: "loadMoreChapters",
    value: function loadMoreChapters() {
      this.seoChapters.classList.remove('is-blurred');
      this.btnLessChapter.classList.remove('kl-hidden');
      this.btnMoreChapter.classList.add('kl-hidden');
    }
  }, {
    key: "loadLessChapters",
    value: function loadLessChapters() {
      this.seoChapters.classList.add('is-blurred');
      this.btnMoreChapter.classList.remove('kl-hidden');
      this.btnLessChapter.classList.add('kl-hidden');
      document.querySelector('.o-zone-seo').scrollIntoView();
    }
  }]);
}();
export default ServiceSolutionHubClass;